<template>
  <div class="default">
    <Header />
    <header-banner
      v-if="
        _.get(this.$store.state.main, 'selected_menu.media.cover') &&
          !_.get(this.$store.state.main.selected_menu, 'routeParams.singleview')
      "
    />
    <router-view />
    <CookiePolicy />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/modules/Header";
import Footer from "@/components/modules/Footer";
import HeaderBanner from "../../components/smartComponents/HeaderBanner.vue";
import CookiePolicy from "../../components/CookiePolicy.vue";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    HeaderBanner,
    CookiePolicy
  }
};
</script>
